import { render, staticRenderFns } from "./group-2.vue?vue&type=template&id=d49f5c3e&scoped=true&"
import script from "./group-2.vue?vue&type=script&lang=js&"
export * from "./group-2.vue?vue&type=script&lang=js&"
import style0 from "./group-2.vue?vue&type=style&index=0&id=d49f5c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49f5c3e",
  null
  
)

export default component.exports